import React from 'react'

const WalletCta = ({title}) => {
  return (
    <div className='py-6 container relative mt-4 mb-10'>
      <p className='text-center text-terciaria text-3xl font-bold'>{title}</p>
      <hr className='absolute h-1 bg-terciaria bottom-0 w-1/3 left-1/2 -translate-x-1/2' />
    </div>
  )
};

export default WalletCta;
